import React from "react";
import {FormattedMessage} from "react-intl";
import firebase from "../../../utils/firebase";
import app from "../../app";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import functions from "../../../utils/functionsFirebase";
import {goHomeAfterLogin} from "../../../utils/utils";

function GoogleLogin({onFinishLogin}) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Create a Google authentication provider
    const provider = new firebase.auth.GoogleAuthProvider();

    const handleGoogleLogin = () => {
        firebase
            .auth()
            .signInWithPopup(provider)
            .then((result) => {
                // Google login successful
                const user = result.user;
                dispatch(app.actions.loading());
                onFinishLogin();
                if(goHomeAfterLogin()) {
                    navigate('/home');
                }

                user.getIdTokenResult().then(token => {
                    if (!token.claims.userCode) {
                        const updateUserCode = functions.httpsCallable('updateUserCode');
                        updateUserCode({userName: user.displayName, userId: user.uid}).then(
                            () => {
                                user.getIdTokenResult(true).then(() => {
                                    dispatch(app.actions.loaded());
                                }).catch((error) => {
                                    console.log(error);
                                });
                            });
                    } else {
                        dispatch(app.actions.loaded());
                    }
                })
                    .catch((error) => {
                        // An error occurred during Google login
                        console.error('Google login error:', error);
                    })
            })
            .catch((error) => {
                // An error occurred during Google login
                console.error('Google login error:', error);
            });
    };

    return (
        <button onClick={handleGoogleLogin} className="btn btn-outline-primary">
            <FormattedMessage id="users.login.google"/> &nbsp;
            <i className="fa-brands fa-google"/>
        </button>
    )
}

export default GoogleLogin;
